var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeTab === 'all' || _vm.card.estateType === _vm.activeTab)?_c('CommonCard',{attrs:{"content":_vm.card,"cardOptions":_vm.cardOptions,"isBooking":false,"modify":"objects-card"},on:{"showOwners":_vm._showOwners}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }